import { getPropsFromNode, nodeMatches } from '../utils'
import { h } from '../parser/utils'

export const NAME = 'iframe'

export function matches(node) {
  return nodeMatches(node, 'iframe')
}

export async function transform (node, next, ctx) {
  const children = await next(node.childNodes, ctx)

  // TODO: be smarter about lazy loading iframes
  const props = {
    ...getPropsFromNode(node),
    loading: 'lazy',
  }

  return h('iframe', props, ...children)
}
